import { useFilterEmployeeSalaryContext } from "./filter-employee-salary.context";

export function FilterEmployeeSalary() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeSalaryContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}